import { Col, Form, Row } from 'antd';
import { RuleObject } from 'antd/lib/form';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';
import ErrModal from 'components/molecules/SpecialniSluzby/ErrModal';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import usePageName from 'hooks/usePageName';
import useProfily from 'hooks/useProfily';

import { ueDatumuhrady, ueDatumvypisu } from 'services/specialniSluzby/ueDatumvypisu';
import { ETypPrevodu, IPozadavkyDLT, uePozadavekDetailDLTApi } from 'services/specialniSluzby/uePozadavky';
import { ISeznamisin, ISeznamisinData, ueSeznamisin } from 'services/specialniSluzby/ueSeznamisin';
import { IZalozeniPost, ueZalozeniDLTPost, ueZalozeniPost } from 'services/specialniSluzby/ueZalozeni';

import routePathEnum from 'enums/routePathEnum';
import { EStavPozadavku } from 'enums/specialniSluzby/stavPozadavku';
import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';

import { typPrevoduSelect } from 'data/codebooks/specialniSluzby/typPrevodu';

import getLanguageObject from 'utils/getLanguageObject';

interface IListIsin {
    value: string;
    labelcz: string;
    evidencecp: string;
    pocetcp: number;
    datumupisu: string;
    misto: number;
    mena: string;
    bankucet: string;
    iban: string;
    typprevodu: ETypPrevodu;
}

const NovyPozadavek: React.FC = () => {
    const { aktivniFirma, language, cisMeny, specialniSluzby } = useContext(Context);
    const { setLevel } = useProfily();
    const { navigateWorkaround } = useNavigateWorkaround();
    const [form] = Form.useForm();
    const [formISIN] = Form.useForm();
    const typ = usePageName();
    const [errStatus, setErrStatus] = useState<number>();
    const [errModalMsg, setErrModalMsg] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const [typPozadavku, setTypPozadavku] = useState<string>('');
    const [dateChecking, setDateChecking] = useState<boolean>(false);
    const [showTypPrevodu, setShowTypPrevodu] = useState<boolean>(false);
    const [dateError, setDateError] = useState<string>();
    const [vyberISIN, setVyberISIN] = useState<boolean>(false);
    const [dataISIN, setDataISIN] = useState<ISeznamisin>();
    const [data, setData] = useState<IPozadavkyDLT>();
    const [listISIN, setListISIN] = useState<IListIsin[]>([]);
    const [tablePaginationISIN, setPaginationISIN] = useState<{
        offset: number;
        page: number;
        limit: number;
    }>({
        offset: 0,
        page: 1,
        limit: 5
    });
    const [zvolenyISIN, setZvolenyISIN] = useState<ISeznamisinData>();
    const [postErr, setPostErr] = useState<string | undefined>('');
    const isDLT = zvolenyISIN?.evidencecp == '21' || zvolenyISIN?.evidencecp == '021';

    const loadISINData = () => {
        setLoading(true);
        // načtu všechny požadavky (případně dle nastaveného filtru)
        const vals = formISIN.getFieldsValue();
        vals.isin = vals.isinForm;
        delete vals.isinForm;
        if (vyberISIN) {
            vals.offset = tablePaginationISIN.offset;
            vals.limit = tablePaginationISIN.limit;
        }
        ueSeznamisin({
            ...vals,
            typ: typPozadavku
        })
            .then((resp: ISeznamisin) => {
                setDataISIN(resp);
                const tmpArr: string[] = [];
                const tmpSelectArr: IListIsin[] = [];
                resp.seznamisin.forEach(item => {
                    if (
                        !tmpArr.includes(item.isin) &&
                        (window.location.href.includes(routePathEnum.SLUZBY_NOVY_UPIS_SICAV)
                            ? item.typ === '520' || item.typ === '510'
                            : window.location.href.includes(routePathEnum.SLUZBY_NOVY_UPIS)
                              ? item.typ !== '520' && item.typ !== '510'
                              : true)
                    ) {
                        tmpArr.push(item.isin);
                        tmpSelectArr.push({
                            value: item.isin,
                            labelcz: item.isin,
                            evidencecp: item.evidencecp,
                            pocetcp: item.pocetcp,
                            datumupisu: item.datumupisu,
                            misto: item.misto,
                            mena: item.mena,
                            bankucet: item.bankucet,
                            iban: item.iban,
                            typprevodu: item.typprevodu
                        });
                    }
                });
                setListISIN(tmpSelectArr);
            })
            .catch((err: any) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => {
                setLoading(false);
                setErrStatus(0);
            });
    };

    useEffect(() => {
        if (specialniSluzby?.detail?.id) {
            uePozadavekDetailDLTApi(specialniSluzby.detail?.id).then((resp: IPozadavkyDLT) => {
                setData(resp);
                setShowTypPrevodu(true);
                //  const ucet = (resp.bankucet || '').split(/-|\//);
                form.setFieldsValue({
                    datum: dayjs(resp.datum),
                    isin: resp.isin
                    /* ...(ucet.length && ucet.length === 3
                        ? {
                              predcisli: ucet[0],
                              cislouctu: ucet[1],
                              banka: ucet[2]
                          }
                        : {
                              cislouctu: ucet[0],
                              banka: ucet[1]
                          }) */
                });
            });
        } else {
            setLoading(false);
        }
        setErrStatus(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data && dataISIN && data.isin) {
            const selectedIsin = dataISIN.seznamisin.filter(e => e.isin === data.isin && data.datum === e.datumupisu);
            selectedIsin.length && setZvolenyISIN(selectedIsin[0]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, dataISIN]);

    useEffect(() => {
        typPozadavku && loadISINData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typPozadavku]);

    useEffect(() => {
        if (typ) {
            setTypPozadavku(typ?.split('-')[1].toUpperCase() || '');
        }
        setZvolenyISIN(undefined);
        setTimeout(() => form.resetFields(), 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typ]);

    const onFinish = () => {
        console.log('onFinish');
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submitISIN = (vals: any) => {
        setLoading(true);
        if (isDLT) {
            ueZalozeniDLTPost(
                {
                    ...(specialniSluzby?.detail?.id && {
                        id: specialniSluzby?.detail?.id
                    }),
                    ...(!specialniSluzby?.detail && {
                        isin: vals.isin,
                        typ: typPozadavku as ETypPozadavku,
                        ...(vals.datum && {
                            datum: vals.datum.format('YYYY-MM-DD')
                        })
                    }),
                    typprevodu: vals.typprevodu,
                    ...(vals.datuhr && {
                        datuhr: vals.datuhr.format(
                            `${vals.datuhr.format('YYYY-MM-DD')}T${vals.datuhr.format('HH:mm:ssZ')}`
                        )
                    }),
                    ...(vals.cenacp && {
                        cenacp: vals.cenacp
                    }),
                    ...(vals.mena && {
                        mena: vals.mena
                    }),
                    ...(vals.bankucet && {
                        bankucet: vals.bankucet
                    }),
                    minpoccp: vals.minpoccp
                },
                specialniSluzby?.detail ? 'PUT' : 'POST'
            )
                .then((resp: IZalozeniPost) => {
                    if (resp.stav?.includes('TIMEOUT')) {
                        setErrModalMsg('SS_SLUZBA_ERROR_NESKORO');
                    } else {
                        setLevel('specialniSluzby', {
                            detail: {
                                isin: vals.isin,
                                ...(vals.datum && {
                                    datum: vals.datum.format('YYYY-MM-DD')
                                }),
                                typprevodu: vals.typprevodu,
                                typ: typPozadavku as ETypPozadavku,
                                ...(vals.datuhr && {
                                    datuhr: vals.datuhr.format(
                                        `${vals.datuhr.format('YYYY-MM-DD')}T${vals.datuhr.format('HH:mm:ssZ')}`
                                    )
                                }),
                                cenacp: vals.cenacp,
                                mena: vals.mena,
                                ...(vals.bankucet && {
                                    bankucet: vals.bankucet
                                }),
                                ...(vals.iban && {
                                    iban: vals.iban
                                }),
                                minpoccp: vals.minpoccp,
                                id: resp.id,
                                stav: EStavPozadavku.OTEVRENO
                            }
                        });
                        navigateWorkaround(
                            `/firma/${aktivniFirma?.iducet}${routePathEnum.SLUZBY_DETAIL_POZADAVKU_DLT}`
                        );
                    }
                })
                .catch((error: any) => {
                    setPostErr(error.response?.data.message);
                })
                .finally(() => setLoading(false));
        } else {
            ueZalozeniPost({
                isin: form.getFieldValue('isin'),
                datum: dayjs(form.getFieldValue('datum')).format('YYYY-MM-DD'),
                typ: typPozadavku,
                cenacp: vals.cenacp
            })
                .then((resp: IZalozeniPost) => {
                    if (resp.stav?.includes('TIMEOUT')) {
                        setErrModalMsg('SS_SLUZBA_ERROR_NESKORO');
                    } else {
                        setLevel('specialniSluzby', {
                            detail: {
                                isin: form.getFieldValue('isin'),
                                datum: dayjs(form.getFieldValue('datum')).format('YYYY-MM-DD'),
                                typ: typPozadavku as ETypPozadavku,
                                id: resp.id,
                                stav: EStavPozadavku.OTEVRENO,
                                ...(vals.typprevodu && {
                                    typprevodu: vals.typprevodu
                                })
                            }
                        });
                        navigateWorkaround(`/firma/${aktivniFirma?.iducet}${routePathEnum.SLUZBY_DETAIL_POZADAVKU}`);
                    }
                })
                .catch((error: any) => {
                    setPostErr(error.response?.data.message);
                })
                .finally(() => setLoading(false));
        }
    };

    const setIsinDatum = (isin: string) => {
        const date = dataISIN?.seznamisin.filter(it => it.isin === isin)[0]?.datumupisu;
        form.setFieldsValue({
            ['datum']: dayjs(date)
        });
        return date;
    };

    const columns = [
        {
            title: <TranslateText>ISIN</TranslateText>,
            dataIndex: 'isin',
            key: 'isin'
        },
        {
            title: <TranslateText>SS_VYBER_ISIN_NAZEV_EMISE</TranslateText>,
            dataIndex: 'celynazev',
            key: 'celynazev'
        },
        {
            title: <TranslateText>IC_EMITENTA</TranslateText>,
            dataIndex: 'icemitenta',
            key: 'icemitenta'
        },
        {
            title: <TranslateText>NAZEV_EMITENTA</TranslateText>,
            dataIndex: 'nazevemitenta',
            key: 'nazevemitenta',
            render: (_text: string, row: ISeznamisinData, index: number) => (
                <AnchorComponent
                    id={`novyPozadavekVybratBtn${index}`}
                    onClick={() => {
                        form.resetFields(['isin']);
                        formISIN.resetFields();
                        typPozadavku === 'UPIS' && setIsinDatum(row.isin);
                        if (row.typprevodu) {
                            setShowTypPrevodu(true);
                            setTimeout(
                                () =>
                                    form.setFieldsValue({
                                        ...row,
                                        predpokladanecp: row.pocetcp
                                    }),
                                0
                            );
                            if (row && (row.evidencecp == '21' || row.evidencecp == '021')) {
                                ueDatumuhrady(dayjs(row.datumupisu).format('YYYY-MM-DD')).then(resp => {
                                    form.setFieldsValue({
                                        datuhr: dayjs(resp.datuhr)
                                    });
                                });
                            }
                        } else {
                            setShowTypPrevodu(false);
                        }
                        setZvolenyISIN(row);
                        setPostErr('');
                        setPaginationISIN({
                            page: 1,
                            offset: 0,
                            limit: 10
                        });
                        setVyberISIN(false);
                    }}
                >
                    <TranslateText>VYBRAT</TranslateText>
                </AnchorComponent>
            )
        }
    ];

    return (
        <LoadingWrapper loading={loading}>
            <Title
                level={4}
                text={`${
                    typ &&
                    getLanguageObject(language)[
                        'SS_NOVY_POZADAVEK_NA_' +
                            (typ.includes('upis-sicav')
                                ? 'UPIS_SICAV'
                                : typPozadavku === ETypPozadavku.NAVYSENI
                                  ? 'NAVYSENISNIZENI'
                                  : typPozadavku)
                    ]
                }`}
            />
            {errStatus ? (
                <Row>
                    <Col span={16}>
                        {errStatus === 404 ? (
                            <Paragraph text="RESPONSE_ERROR_404" />
                        ) : errStatus ? (
                            <Paragraph text="SLUZBA_NEDOSTUPNA" />
                        ) : null}
                        <Row className="button-row">
                            <ButtonComponent
                                id="errZpetBtn"
                                buttontext="ZPET"
                                type="default"
                                onClick={() => {
                                    setErrStatus(0);
                                }}
                            />
                        </Row>
                    </Col>
                </Row>
            ) : !vyberISIN ? (
                <FormWrapper onFinish={submitISIN} layoutPosition="vertical" outForm={form}>
                    <Row gutter={12}>
                        <Col span={12}>
                            <SelectComponent
                                name="isin"
                                labelParagraph={'ISIN'}
                                data={listISIN as { value: string; labelcz: string }[]}
                                value={zvolenyISIN?.isin}
                                defaultValue={zvolenyISIN?.isin || data?.isin}
                                disabled={!!specialniSluzby?.detail?.id}
                                isFormItem={true}
                                extramessage={postErr && !postErr.includes('Datum') ? 'SS_ERR_ISIN_PRAVO' : undefined}
                                onChange={(value, item) => {
                                    const selectedVal = listISIN[item.key];
                                    if (selectedVal.typprevodu && typPozadavku !== ETypPozadavku.NAVYSENI) {
                                        setTimeout(
                                            () =>
                                                form.setFieldsValue({
                                                    ...selectedVal,
                                                    predpokladanecp: selectedVal.pocetcp
                                                }),
                                            0
                                        );
                                        setShowTypPrevodu(true);
                                        if (
                                            selectedVal &&
                                            (selectedVal.evidencecp == '21' || selectedVal.evidencecp == '021')
                                        ) {
                                            ueDatumuhrady(dayjs(selectedVal.datumupisu).format('YYYY-MM-DD')).then(
                                                resp => {
                                                    form.setFieldsValue({
                                                        datuhr: dayjs(resp.datuhr)
                                                    });
                                                }
                                            );
                                        }
                                    }
                                    if (!selectedVal.typprevodu) {
                                        setShowTypPrevodu(false);
                                    }
                                    typPozadavku === 'UPIS' && setIsinDatum(value);
                                    typPozadavku !== ETypPozadavku.NAVYSENI &&
                                        setZvolenyISIN(
                                            dataISIN!.seznamisin.filter(
                                                e => e.isin === value && selectedVal.datumupisu === e.datumupisu
                                            )[0]
                                        );
                                    postErr !== '' && setPostErr('');
                                }}
                            />
                        </Col>
                        {!specialniSluzby?.detail?.id && (
                            <Col
                                span={12}
                                style={{
                                    paddingTop: '35px'
                                }}
                            >
                                <ButtonComponent
                                    id="zpetBtn"
                                    buttontext="VYBRAT_ISIN"
                                    onClick={() => {
                                        formISIN.resetFields();
                                        setVyberISIN(true);
                                    }}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row gutter={12}>
                        <Col span={12}>
                            <LoadingWrapper loading={dateChecking}>
                                <DatePickerComponent
                                    name="datum"
                                    label={`${getLanguageObject(language).PREDPOKLADANE_DATUM} ${
                                        getLanguageObject(language)['SS_DATUM_' + typPozadavku]
                                    }`}
                                    initialValue={data?.datum ? dayjs(data.datum) : undefined}
                                    defaultPickerValue={typPozadavku !== 'UPIS' && form.getFieldValue('datum')}
                                    disabled={typPozadavku === 'UPIS'}
                                    disabledDate={current =>
                                        (typPozadavku === 'SICAV' && zvolenyISIN?.datumupisu
                                            ? dayjs(zvolenyISIN?.datumupisu).add(1, 'd') > current
                                            : dayjs() > current) || current > dayjs().add(30, 'd')
                                    }
                                    extramessage={
                                        (!!postErr || dateError) && postErr?.includes('Datum')
                                            ? 'NEVALIDNI_DATUM_MIMO_INTERVAL'
                                            : dateError
                                    }
                                    onOpenChange={() => {
                                        postErr !== '' && setPostErr('');
                                        setDateError('');
                                    }}
                                    rules={[
                                        {
                                            required: typPozadavku !== 'UPIS',
                                            message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                                        },
                                        () => ({
                                            async validator(_rule: RuleObject, value: dayjs.Dayjs) {
                                                if (dateError) return Promise.reject();
                                                if (value) {
                                                    if (typPozadavku === ETypPozadavku.NAVYSENI && dataISIN) {
                                                        const listOfSelectedIsins = dataISIN.seznamisin.filter(e => {
                                                            return (
                                                                e.isin === form.getFieldValue('isin') &&
                                                                value.format('YYYY-MM-DD') ===
                                                                    dayjs(e.datumupisu).format('YYYY-MM-DD')
                                                            );
                                                        });
                                                        if (!listOfSelectedIsins.length) {
                                                            setTimeout(() => setDateError('UPIS_NAVYSENI_DATE_ERR'), 0);
                                                            return Promise.reject();
                                                        }
                                                        setTimeout(
                                                            () =>
                                                                form.setFieldsValue({
                                                                    ...listOfSelectedIsins[0],
                                                                    predpokladanecp: listOfSelectedIsins[0].pocetcp
                                                                }),
                                                            0
                                                        );
                                                        setShowTypPrevodu(true);
                                                        if (
                                                            listOfSelectedIsins[0] &&
                                                            (listOfSelectedIsins[0].evidencecp == '21' ||
                                                                listOfSelectedIsins[0].evidencecp == '021')
                                                        ) {
                                                            ueDatumuhrady(
                                                                dayjs(listOfSelectedIsins[0].datumupisu).format(
                                                                    'YYYY-MM-DD'
                                                                )
                                                            ).then(resp => {
                                                                form.setFieldsValue({
                                                                    datuhr: dayjs(resp.datuhr)
                                                                });
                                                            });
                                                        }
                                                        setZvolenyISIN(listOfSelectedIsins[0]);
                                                    }
                                                    if (zvolenyISIN?.isin === 'CZ1005101004') return Promise.resolve();
                                                    setDateChecking(true);
                                                    return ueDatumvypisu(
                                                        value.format('YYYY-MM-DD'),
                                                        zvolenyISIN?.mena || data?.mena
                                                    )
                                                        .then(resp =>
                                                            resp.stav === 'LZE'
                                                                ? (setDateChecking(false),
                                                                  setDateError(''),
                                                                  Promise.resolve())
                                                                : resp.stav === 'NELZE'
                                                                  ? (setDateChecking(false),
                                                                    Promise.reject(setDateError('CHYBA_SLUZBY_DATUM')))
                                                                  : resp.stav === 'NELZEISIN'
                                                                    ? (setDateChecking(false),
                                                                      Promise.reject(
                                                                          setDateError('CHYBA_SLUZBY_NELZEISIN')
                                                                      ))
                                                                    : (setDateChecking(false),
                                                                      Promise.reject(
                                                                          setDateError('CHYBA_SLUZBY')
                                                                      )).catch(() => {
                                                                          setDateChecking(false);
                                                                          Promise.reject(setDateError('CHYBA_SLUZBY'));
                                                                      })
                                                        )
                                                        .catch(() => {
                                                            setDateChecking(false);
                                                            Promise.reject(<TranslateText>CHYBA_SLUZBY</TranslateText>);
                                                        });
                                                }
                                            }
                                        })
                                    ]}
                                />
                            </LoadingWrapper>
                            {showTypPrevodu && (
                                <SelectComponent
                                    isFormItem={true}
                                    data={typPrevoduSelect}
                                    defaultValue={zvolenyISIN?.typprevodu || data?.typprevodu}
                                    name="typprevodu"
                                    labelParagraph="TYP_PREVODU"
                                    showTooltipValue={true}
                                    disabled={true}
                                    infoTooltipText={
                                        <>
                                            <Row>
                                                <Paragraph
                                                    text="TYP_PREVODU_DFP"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                            <Row>
                                                <Paragraph
                                                    text="DFP_TEXT1"
                                                    style={{
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                            <Row>
                                                <Paragraph
                                                    text="DFP_TEXT2"
                                                    style={{
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                            <Row>
                                                <Paragraph
                                                    text="TYP_PREVODU_DVP"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                            <Row>
                                                <Paragraph
                                                    text="DVP_TEXT1"
                                                    style={{
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                            <Row>
                                                <Paragraph
                                                    text="DVP_TEXT2"
                                                    style={{
                                                        color: '#fff'
                                                    }}
                                                />
                                            </Row>
                                        </>
                                    }
                                />
                            )}
                            {((zvolenyISIN?.typprevodu || data?.typprevodu) === ETypPrevodu.PROTIZAPLACENI ||
                                (zvolenyISIN?.typprevodu || data?.typprevodu) === ETypPrevodu.PROTIABEZZAPL) && (
                                <>
                                    {isDLT && form.getFieldValue('datum') && (
                                        <LoadingWrapper loading={dateChecking}>
                                            <DatePickerComponent
                                                name="datuhr"
                                                initialValue={data?.datuhr ? dayjs(data.datuhr) : undefined}
                                                format={value => `${value.format('DD.MM.YYYY HH:mm')}`}
                                                // disabled={true}
                                                label="DATUN_UHRADY_LATEST"
                                                disabledDate={current =>
                                                    current <= dayjs() && current < form.getFieldValue('datum')
                                                }
                                                rules={[
                                                    {
                                                        required: typPozadavku !== 'UPIS',
                                                        message: (
                                                            <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                                                        )
                                                    }
                                                    /*  () => ({
                                                            async validator(_rule: RuleObject, value: dayjs.Dayjs) {
                                                                if (dateError) return Promise.reject();
                                                                if (value) {
                                                                    setDateChecking(true);
                                                                    return ueDatumuhradyKontrola(
                                                                        form
                                                                            .getFieldValue('datum')
                                                                            .format('YYYY-MM-DD'),
                                                                        value.format('YYYY-MM-DD')
                                                                    )
                                                                        .then(resp =>
                                                                            resp.stav
                                                                                ? (setDateChecking(false),
                                                                                  setDateError(''),
                                                                                  Promise.resolve())
                                                                                : !resp.stav
                                                                                  ? (setDateChecking(false),
                                                                                    Promise.reject(
                                                                                        setDateError(
                                                                                            'CHYBA_SLUZBY_DATUM'
                                                                                        )
                                                                                    ))
                                                                                  : (setDateChecking(false),
                                                                                    Promise.reject(
                                                                                        setDateError('CHYBA_SLUZBY')
                                                                                    )).catch(() => {
                                                                                        setDateChecking(false);
                                                                                        Promise.reject(
                                                                                            setDateError('CHYBA_SLUZBY')
                                                                                        );
                                                                                    })
                                                                        )
                                                                        .catch(() => {
                                                                            setDateChecking(false);
                                                                            Promise.reject(
                                                                                setDateError('CHYBA_SLUZBY')
                                                                            );
                                                                        });
                                                                }
                                                            } 
                                                        }) */
                                                ]}
                                            />
                                        </LoadingWrapper>
                                    )}

                                    {(zvolenyISIN?.mena || data?.mena) && (
                                        <SelectComponent
                                            isFormItem={true}
                                            name="mena"
                                            defaultValue={zvolenyISIN?.mena || data?.mena}
                                            labelParagraph="MENA"
                                            data={cisMeny}
                                            disabled={true}
                                        />
                                    )}
                                    {zvolenyISIN?.bankucet || data?.bankucet ? (
                                        <InputComponent
                                            label={'VYPLATA_BANKUC'}
                                            name="bankucet"
                                            notRequired={true}
                                            disabled={true}
                                            initialValue={zvolenyISIN?.bankucet || data?.bankucet}
                                        />
                                    ) : zvolenyISIN?.iban || data?.iban ? (
                                        <InputComponent
                                            label={'IBAN'}
                                            name="iban"
                                            notRequired={true}
                                            disabled={true}
                                            initialValue={zvolenyISIN?.iban || data?.iban}
                                        />
                                    ) : (
                                        <Paragraph
                                            text="DVP_BANKUCET_NULL"
                                            style={{
                                                display: 'block',
                                                marginBottom: 26,
                                                fontWeight: 'bold'
                                            }}
                                        />
                                    )}
                                </>
                            )}

                            {(zvolenyISIN?.typprevodu || data?.typprevodu) && (
                                <InputNumberComponent
                                    name="predpokladanecp"
                                    label={
                                        typPozadavku === ETypPozadavku.NAVYSENI
                                            ? 'POCET_CP_ZMENA'
                                            : 'PREDPOKLADANY_POCET_CP'
                                    }
                                    // maxLength={12}
                                    notRequired={true}
                                    disabled={true}
                                    initialValue={zvolenyISIN?.pocetcp || data?.pocetcp}
                                />
                            )}
                            {isDLT &&
                                ((zvolenyISIN?.typprevodu || data?.typprevodu) === ETypPrevodu.PROTIZAPLACENI ||
                                    (zvolenyISIN?.typprevodu || data?.typprevodu) === ETypPrevodu.PROTIABEZZAPL) && (
                                    <InputNumberComponent
                                        name="minpoccp"
                                        label="MIN_POCET_CP"
                                        initialValue={dataISIN?.pocetcp || data?.minpoccp}
                                        rules={[
                                            () => ({
                                                async validator(_rule: RuleObject, value: string) {
                                                    if (value) {
                                                        if (
                                                            Number(value || 0) <=
                                                            Number(form.getFieldValue('predpokladanecp') || 0)
                                                        ) {
                                                            Promise.resolve();
                                                        } else {
                                                            return Promise.reject(
                                                                <TranslateText>MIN_POCET_CP_ERR</TranslateText>
                                                            );
                                                        }
                                                    }
                                                }
                                            })
                                        ]}
                                    />
                                )}
                        </Col>
                    </Row>
                    <Row className="button-row">
                        {specialniSluzby?.detail && (
                            <ButtonComponent
                                onClick={() => navigateWorkaround(-1)}
                                buttontext="ZPET"
                                id="novySubmitBtn"
                                type="default"
                            />
                        )}
                        <ButtonComponent onClick={() => form.submit()} buttontext="POKRACOVAT" id="novySubmitBtn" />
                    </Row>
                </FormWrapper>
            ) : (
                <>
                    <Title level={3} text={'SS_VYBER_ISIN_FILTR_EMISI'} />
                    <FormWrapper onFinish={onFinish} outForm={formISIN}>
                        <Row gutter={12}>
                            <Col span={6}>
                                <InputComponent name="isinFilter" label="ISIN" notRequired={true} capitalize={true} />
                            </Col>
                            <Col span={6}>
                                <InputComponent
                                    name="nazevemise"
                                    label="SS_VYBER_ISIN_NAZEV_EMISE"
                                    notRequired={true}
                                />
                            </Col>
                            <Col span={6}>
                                <InputComponent
                                    name="idemitenta(ic)"
                                    label="SEZNAM_ISINU_ID_EMITENTA"
                                    notRequired={true}
                                />
                            </Col>
                            <Col span={6}>
                                <InputComponent name="nazevemitenta" label="NAZEV_EMITENTA" notRequired={true} />
                            </Col>
                        </Row>
                        <Row className="button-row-modal">
                            <ButtonComponent
                                id="filtrovatBtn"
                                buttontext="FILTROVAT"
                                onClick={() => {
                                    loadISINData();
                                }}
                            />
                            <ButtonComponent
                                id="resetFiltrBtn"
                                buttontext="VSECHNY"
                                onClick={() => {
                                    formISIN.resetFields();
                                    loadISINData();
                                }}
                            />
                        </Row>
                    </FormWrapper>
                    <TableComponent
                        rowKey={(_, index) => index || 0}
                        columns={columns}
                        dataSource={dataISIN?.seznamisin.filter(e =>
                            window.location.href.includes(routePathEnum.SLUZBY_NOVY_UPIS_SICAV)
                                ? e.typ === '520' || e.typ === '510'
                                : window.location.href.includes(routePathEnum.SLUZBY_NOVY_UPIS)
                                  ? e.typ !== '520' && e.typ !== '510'
                                  : true
                        )}
                        locale={{
                            emptyText: <TranslateText>TABULKA_ZADNE_ZAZNAMY</TranslateText>
                        }}
                        pagination={{
                            total: dataISIN?.seznamisin.length,
                            onChange: page => {
                                setPaginationISIN({
                                    page: page,
                                    offset: (tablePaginationISIN.page - 1) * tablePaginationISIN.limit,
                                    limit: tablePaginationISIN.limit
                                });
                            },
                            current: tablePaginationISIN.offset / tablePaginationISIN.limit + 1,
                            showSizeChanger: false
                        }}
                    />

                    <Row className="button-row">
                        <ButtonComponent
                            id="zpetBtn"
                            buttontext="ZPET"
                            type="default"
                            onClick={() => {
                                setVyberISIN(false);
                                setPaginationISIN({
                                    page: 1,
                                    offset: 0,
                                    limit: 10
                                });
                                // setDataISIN(undefined);
                            }}
                        />
                    </Row>
                </>
            )}
            <ErrModal modalMsg={errModalMsg} setModalMsg={setErrModalMsg} />
        </LoadingWrapper>
    );
};

export default NovyPozadavek;
